// src/components/BestSellers.jsx

import React, { useRef } from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import ProductLoader from "../../Loader/ProductLoader";
import { CiCircleChevRight, CiCircleChevLeft } from "react-icons/ci";

// ❗️ Make sure this path points to your tall, portrait-oriented image
import staticImageSrc from "../../../assets/images/home/home1.png";

const BestSellers = ({ products, isLoading }) => {
  const scrollContainerRef = useRef(null);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 200; // Adjusted scroll for smaller cards
      if (direction === "left") {
        scrollContainerRef.current.scrollLeft -= scrollAmount;
      } else {
        scrollContainerRef.current.scrollLeft += scrollAmount;
      }
    }
  };

  // The sorting function remains the same
  const sortedProducts = (products) => {
    if (!products) return [];
    return [...products].sort((a, b) => b.count - a.count);
  };

  return (
    // CHANGE: Switched to white background and adjusted padding for a cleaner look
    <div className="w-full py-16 bg-white px-4">
      <div className="max-w-screen-xl mx-auto">
        {/* CHANGE: Added items-stretch to make columns equal height and increased spacing */}
        <div className="flex flex-col lg:flex-row lg:space-x-12 lg:items-stretch">
          
          {/* Left Side - Static Image Section */}
          {/* CHANGE: Adjusted column width */}
          <div className="w-full lg:w-2/4 mb-8 lg:mb-0">
            <img
              src={staticImageSrc}
              alt="Best Sellers"
              // CHANGE: Set image to h-full to fill the container's height
              className="w-full h-full object-cover"
            />
          </div>

          {/* Right Side - Best Sellers Section */}
          {/* CHANGE: Adjusted column width */}
          <div className="w-full lg:w-3/5">
            <div className="flex justify-between items-center mb-6">
              <Heading
                heading="Best Sellers"
                className="text-2xl font-semibold text-gray-900"
              />
              {products && products.length > 4 && (
                <div className="flex space-x-2">
                  <button onClick={() => scroll("left")}>
                    <CiCircleChevLeft className="w-8 h-8 text-gray-500 hover:text-black" />
                  </button>
                  <button onClick={() => scroll("right")}>
                    <CiCircleChevRight className="w-8 h-8 text-gray-500 hover:text-black" />
                  </button>
                </div>
              )}
            </div>

            {isLoading ? (
              <ProductLoader />
            ) : products && products.length > 0 ? (
              <div
                ref={scrollContainerRef}
                className="flex items-start space-x-4 overflow-x-auto scroll-smooth hide-scrollbar"
              >
                {sortedProducts(products).map((product) => (
                  <div
                    key={product._id}
                    className="flex-shrink-0 w-60"
                  >
                    <Product product={product} variant="minimal" />
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <p className="text-lg text-gray-500">
                  No best-selling products found.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BestSellers;